import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useCallback } from 'react';
import * as ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import * as classnames from 'classnames';
import { pop_back_item, push_back_item } from '../utils/back-button';
import './dialogs.sass';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Button } from '@mui/material';
const DialogFrame = ({ open, children, frameClass = '', frameStyle, size, warning = false, success = false, faderClass = '', overflowVisible = false, closeOnOutsideClick = true, onRequestClose, }) => {
    const on_fader_click = useCallback((ev) => {
        if (open && closeOnOutsideClick) {
            onRequestClose?.();
        }
    }, [open, closeOnOutsideClick, onRequestClose]);
    return (_jsxs(React.Fragment, { children: [_jsx("div", { className: classnames('r-dialog-fader', faderClass), onTouchStart: on_fader_click, onMouseDown: on_fader_click, onClick: on_fader_click }), _jsx("div", { className: classnames('r-dialog-frame', 'r-dialog-typography', frameClass, {
                    'r-message-box-warning': warning,
                    'r-message-box-success': success,
                    'r-dialog-overflow-visible': overflowVisible,
                    [`r-dialog-${size}`]: size != null,
                }), style: frameStyle, children: children })] }));
};
class DialogProxy extends React.Component {
    socket;
    div;
    transitionEndTimer;
    constructor(props
    // & {classes: Record<'root', string>}
    ) {
        super(props);
        this.state = {
            still_visible: this.props.open,
        };
        this.div = document.createElement('div');
        this.div.className = this._container_class(props.open);
        this.div.style.display = 'none';
        this.div.style.zIndex = this.props.zIndex?.toString() ?? '';
        this.div.addEventListener('transitionend', this.on_transition_end);
        this.div.addEventListener('webkitTransitionEnd', this.on_transition_end);
        this.div.addEventListener('oTransitionEnd', this.on_transition_end);
        this.transitionEndTimer = window.setTimeout(this.on_transition_end, 750);
        this._update_container();
    }
    componentDidMount() {
        this.socket = document.querySelector('.theme-general-div') ?? document.body;
        this.socket?.appendChild(this.div);
        if (this.props.open && !this.props.dontAddBackItem)
            push_back_item(() => this.props.onRequestClose?.());
    }
    componentWillUnmount() {
        clearTimeout(this.transitionEndTimer);
        this.div.removeEventListener('transitionend', this.on_transition_end);
        this.div.removeEventListener('webkitTransitionEnd', this.on_transition_end);
        this.div.removeEventListener('oTransitionEnd', this.on_transition_end);
        this.socket?.removeChild(this.div);
        if (this.props.open && !this.props.dontAddBackItem)
            pop_back_item();
    }
    componentDidUpdate(prevProps
    // & {classes: Record<'root', string>}
    ) {
        // noinspection PointlessBooleanExpressionJS
        if (!!this.props.open !== !!prevProps.open) {
            this._update_container();
            if (this.props.open)
                this.setState({ still_visible: true });
            if (!this.props.dontAddBackItem) {
                if (this.props.open)
                    push_back_item(() => this.props.onRequestClose?.());
                else
                    pop_back_item();
            }
        }
        // else if (this.props.classes.root != prevProps.classes.root)
        //     this._update_container();
    }
    on_transition_end = () => {
        clearTimeout(this.transitionEndTimer);
        this.div.style.display = this.props.open ? '' : 'none';
        if (!this.props.open) {
            this.setState({ still_visible: false });
            this.props.onCloseAnimationEnd?.();
        }
    };
    _container_class(open) {
        return classnames(
        // this.props.classes.root,
        'r-dialog-container', this.props.containerClass, {
            'r-dialog-open': open,
        });
    }
    _update_container() {
        if (this.props.open) {
            this.div.style.display = '';
            setTimeout(() => {
                this.div.className = this._container_class(true);
            }, 1);
        }
        else
            this.div.className = this._container_class(false);
    }
    render() {
        if (this.props.open || this.state.still_visible)
            return ReactDOM.createPortal(_jsx(DialogFrame, { ...this.props }), this.div);
        return null;
    }
}
export class HeaderFooterDialog extends React.Component {
    header;
    body;
    footer;
    set_header = (header) => {
        this.header = header;
    };
    set_body = (body) => {
        this.body = body;
        this.props.refBody?.(this.body);
    };
    set_footer = (footer) => {
        this.footer = footer;
    };
    render() {
        return (_jsxs(DialogProxy, { ...this.props, children: [(this.props.header != null || this.props.onRequestClose != null) && (_jsxs("div", { className: "r-dialog-header", ref: this.set_header, children: [_jsx("div", { className: classnames('r-dialog-header-content', {
                                'with-close': this.props.onRequestClose != null,
                            }), children: this.props.header != null &&
                                React.Children.only(this.props.header) }), this.props.onRequestClose != null && (_jsx("div", { className: "r-dialog-close", onClick: this.props.onRequestClose }))] })), _jsx("div", { ref: this.set_body, className: classnames('r-dialog-body', {
                        'r-dialog-full-height': this.props.fullHeight,
                        //'r-dialog-non-scrollable': @props.nonScrollable,
                        'r-dialog-body-with-footer': this.props.footer != null,
                        'r-dialog-body-without-horizontal-padding': this.props.withoutHorizontalPadding,
                        'r-dialog-overflow-visible': this.props.overflowVisible,
                    }), children: this.props.children }), this.props.footer != null && (_jsx("div", { className: "r-dialog-footer", ref: this.set_footer, children: this.props.footer }))] }));
    }
}
export const MessageBox = (props) => (_jsx(HeaderFooterDialog, { frameClass: classnames('r-message-box', props.frameClass), header: props.title != null ? _jsx("h1", { style: props.titleStyle, children: props.title }) : null, ...props, children: props.children }));
export const ButtonBox = (props) => (_jsx("div", { className: "r-button-box", style: props.style, children: props.children }));
export const nonreact_messagebox = ({ open = true, remove_after_close = true, size, title, message, on_close, on_close_by_user, close_on_outside_click = true, error, buttons, frameClass, dom_element, ...props }) => {
    const on_request_close = (by_user = true) => {
        if (!open)
            return;
        open = false;
        update();
        if (by_user)
            on_close_by_user?.();
    };
    const render = () => {
        const footer = buttons != null ? (_jsx(ButtonBox, { style: { marginTop: '1em' }, children: buttons.map((button_spec, i) => (_jsx(Button, { className: button_spec.warning ? 'warning' : '', onClick: button_spec.click, color: 'error', variant: 'outlined', sx: {
                    color: '#c4443b',
                }, children: button_spec.text }, i))) })) : null;
        return (_jsx(MessageBox, { open: open, size: size || 'small', title: title, warning: !!error, footer: footer, frameClass: frameClass, closeOnOutsideClick: close_on_outside_click, onRequestClose: on_request_close, onCloseAnimationEnd: () => {
                if (remove_after_close) {
                    root.unmount();
                    on_close?.();
                }
            }, ...props, children: dom_element ? (_jsx("div", { ref: dom_element })) : (_jsx("div", { dangerouslySetInnerHTML: { __html: message } })) }));
    };
    const container = document.createElement('div');
    //Если добавлять, то появляется div, которая пол-экрана заслоняет
    // document.querySelector('.theme-general-div')?.appendChild(container);
    const root = createRoot(container);
    const update = () => {
        root.render(render());
    };
    update();
    return {
        close: () => on_request_close(false),
        hide: () => {
            open = false;
            update();
        },
        show: () => {
            open = true;
            update();
        },
    };
};
